import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from 'components/IconButton/IconButton';
import Select from 'components/form/Select';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { formatPhoneNumber } from 'utils';

const CallingFrom = ({ fromNumber, onChange, onClose }) => {
  const connections = useSelector((state) => state.user.user.connections);

  const options = connections.map((connection) => ({
    value: connection.conn_address,
    label: formatPhoneNumber(connection.conn_address),
  }));

  useEffect(() => {
    if (options.length > 0 && !fromNumber) {
      onChange(options[0].value);
    }
  }, [fromNumber]);

  return (
    <Stack alignItems="center" direction="row" spacing={1} mb={3}>
      <Typography fontWeight={500} sx={{ flexShrink: 0 }}>
        Calling from
      </Typography>
      <Select
        transformValue
        fullWidth
        size="mini"
        margin="none"
        value={fromNumber}
        onChange={onChange}
        options={options}
      />
      <Box textAlign="right" minWidth={60}>
        <IconButton icon={<CloseIcon />} onClick={onClose} />
      </Box>
    </Stack>
  );
};

export default CallingFrom;
